import { useReactFlow, useStoreApi } from "@xyflow/react";


export default function useFocusNode() {
  const store = useStoreApi();
  const { setCenter } = useReactFlow();

  const focusNode = (nodeId: string, params: {
    xOffset?: number;
    zoom?: number;
  } = {}) => {
    const { nodeLookup } = store.getState();
    const nodes = Array.from(nodeLookup).map(([, node]) => node);

    if (nodes.length > 0) {
      const node = nodes.find(n => n.id === nodeId);

      if (!node?.measured?.width || !node?.measured?.height) return;

      const x = (node.position.x + node.measured.width / 2) + (params.xOffset || 0)
      const y = node.position.y + node.measured.height / 2;
      const zoom = params.zoom ?? 1.2;

      setCenter(x, y, { zoom, duration: 1000 });
    }
  };

  return { focusNode };
};
